import React from 'react';
import PropTypes from 'prop-types';
import { grayDarkM } from 'web-ui-kit/colors';
var VARIANT_STYLES = {
  'default': {
    'width': '10',
    'color': grayDarkM
  }
};
var VARIANTS = ['', 'default'];

function CaretDown(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? undefined : _ref$ariaLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var derivedWidth = VARIANT_STYLES[variant]['width'];
  var derivedColor = color || VARIANT_STYLES[variant]['color'];
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": ariaLabel,
      className: className,
      width: derivedWidth,
      style: {
        cursor: 'pointer'
      },
      viewBox: "0 0 10 5",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: onClick
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M0 0L5 5L10 0H0Z",
      fill: derivedColor
    }))
  );
}

CaretDown.propTypes = {
  /** fill color (overrides variant if provided) */
  color: PropTypes.string,

  /** allow css style override */
  className: PropTypes.string,

  /** callback for click event */
  onClick: PropTypes.func,

  /** name of predefined styles */
  variant: PropTypes.oneOf(VARIANTS)
};
export default CaretDown;
export { VARIANTS, VARIANT_STYLES };